import { ReactNode } from 'react'
import { ParseKeys } from 'i18next'
import { useTranslation } from 'next-i18next'
import { twMerge } from 'tailwind-merge'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import SioLogoIcon from 'shared/icons/sio-logo-icon'
import { PUBLIC_LAYOUT_X_PADDING } from '../constants/public-layout-constants'
import DesktopMenu from './components/desktop-menu'
import MobileMenu from './components/mobile-menu'

const PublicHeader = ({ title }: { title: ParseKeys }): ReactNode => {
  const { t } = useTranslation()

  return (
    <header className="static h-auto w-full bg-bg-primary font-inter text-text-primary">
      <div
        className={twMerge(
          PUBLIC_LAYOUT_X_PADDING,
          'mx-auto flex h-[69px] w-full max-w-[1120px] items-center justify-between gap-5',
        )}
      >
        <LinkWithoutPrefetch
          href="/"
          className="w-fit rounded-md outline-hidden focus-visible:focus-ring-primary"
        >
          <SioLogoIcon className="h-8 w-auto shrink-0" />
        </LinkWithoutPrefetch>
        <DesktopMenu />
        <MobileMenu />
      </div>
      {title && (
        <h1
          className={twMerge(
            PUBLIC_LAYOUT_X_PADDING,
            'mx-auto max-w-[1120px] py-16 font-inter text-[35px] leading-normal font-semibold text-text-primary lg:py-24 lg:text-[56px]',
          )}
        >
          {t(title)}
        </h1>
      )}
    </header>
  )
}

export default PublicHeader
